module.exports = __webpack_public_path__ + "static/media/Force_start.bf920dae.mp4";